/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_AccountInputs */

const en_directory_sidebar_account = /** @type {(inputs: Directory_Sidebar_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const zh_directory_sidebar_account = /** @type {(inputs: Directory_Sidebar_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Directory_Sidebar_AccountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_account = /** @type {((inputs?: Directory_Sidebar_AccountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_AccountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_account(inputs)
	return zh_directory_sidebar_account(inputs)
});
export { directory_sidebar_account as "directory.sidebar.account" }